import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error("Token ausente. Solicite novamente.");
    if (password.length < 6) return toast.error("Senha deve ter pelo menos 6 caracteres");
    if (password !== confirm) return toast.error("Senhas não conferem");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Senha redefinida com sucesso");
      nav("/entrar");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-10 sm:py-16">
      <h1 className="text-3xl font-bold text-center" style={{ fontFamily: "Outfit" }}>Redefinir senha</h1>
      <form onSubmit={submit} className="mt-8 space-y-4 bg-white border rounded-xl p-6">
        {!token && <p className="text-sm text-red-600" data-testid="reset-no-token">Token ausente. <Link to="/recuperar-senha" className="underline">Solicitar novamente</Link>.</p>}
        <div>
          <Label>Nova senha</Label>
          <div className="relative">
            <Input data-testid="reset-password" type={show ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="pr-10" />
            <button type="button" onClick={() => setShow((v) => !v)} className="absolute right-2 top-1/2 -translate-y-1/2 text-neutral-500 p-1" aria-label={show ? "Ocultar" : "Mostrar"}>
              {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
        </div>
        <div>
          <Label>Confirmar nova senha</Label>
          <Input data-testid="reset-confirm" type={show ? "text" : "password"} value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6} />
        </div>
        <Button data-testid="reset-submit" type="submit" disabled={loading || !token} className="w-full bg-[#C91F1F] hover:bg-[#9F1515] h-11">
          {loading ? "Salvando..." : "Redefinir senha"}
        </Button>
      </form>
    </div>
  );
}
